APP.Tooltip = (/** @lends APP.Tooltip */function () {
	'use strict';

	var exports,
		$body;

	function init() {
		console.log('tooltip init');
		if (typeof $.fn.tipso === 'undefined') {
			console.log('tipso undefined');
			return false;
		}
		setTipso();
	}

	function setTipso() {
		$body = APP.Performance.getCachedDOM().$body;
		updateWithin($body);
		$body.on({
			'mouseleave, mouseout': function () {
				$(this).remove();
			}
		}, '.tipso_bubble');
	}

	function updateWithin($context) {
		$context.find('[data-tooltip], .tooltip:not([data-tooltip-initialized]):not(.tooltip--nohover)').attr('data-tooltip-initialized', true).tipso({
			background: null,
			color: null,
			maxWidth: 250,
			onBeforeShow: onBeforeShow
		});

		setTimeout(function () {
			$context.find('.visible-tooltip').each(function() {
				var configObj = {
					background: null,
					color: null,
					maxWidth: 250,
					tooltipHover: false,
					alwaysVisible: true,
					onBeforeShow: onBeforeShow
				};

				if(typeof $(this).attr('data-tipso-position') !== 'undefined') {
					configObj.position = $(this).attr('data-tipso-position');
					configObj.forcePosition = true;
				}

				$(this).tipso(configObj).tipso('show');

			});
		}, 600);
	}

	function onBeforeShow(helper) {
		var $indicator = helper[0].element,
			$bubble = helper[0].tipso_bubble;

		if ($indicator.parents('[data-overlay]').length > 0) {
			$bubble.addClass('tooltip--in-overlay');
		} else {
			$bubble.addClass('tooltip--out-overlay');
		}
	}

	function reposition() {
		$body.find('.tipso_style').tipso('reposition');
	}

	exports = {
		init: init,
		updateWithin: updateWithin,
		reposition: reposition
	};

	return exports;

}());
